import Captcha from '@/components/common/captcha/Captcha.vue';

export default {
  name: 'UserResetPassword',
  data: function () {
    return {
      name: '',
      email: '',
      password: '',
      passwordRepeat: '',
      pageLoading: true,
      loading: false,
      apiId: null,
      resetToken: null,
      formSuccess: false,
      errorMsg: null,
      captcha: {}
    }
  },
  components: {
    Captcha
  },
  validations: {
    passwordRepeat: {
      sameAsPassword: function (value, vm) {
        return (value === vm.password)
      },
      validatepassword: function (value) {
        /*
        const containsUppercase = /[A-Z]/.test(value)
        const containsLowercase = /[a-z]/.test(value)
        const containsNumber = /[0-9]/.test(value)
        const containsSpecial = /[#?!@$%^&*-]/.test(value)
        return (value.length > 5 && containsUppercase && containsLowercase && containsNumber && containsSpecial);
         */
        return (value.length > 5);
      }
    }
  },
  methods: {
    generateResetPassword () {
      this.loading = true;
      const reqData = { user: { email: this.email }, captcha_key: this.captcha.key, captcha_value: this.captcha.value };
      const self = this;
      this.ApiRequest.request('user/reset-password/reset', this.ApiRequest.REQUEST_POST, reqData, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self)
        } else {
          self.formSuccess = true;
        }
        if (response.captcha) {
          self.$refs.captchainput.resetCaptcha(response.captcha);
        }
        self.loading = false;
      });
    },
    changePassword () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const path = 'user/reset-password/change-password/' + this.apiId;
        const reqData = { token: this.resetToken, user: { password: this.password, passwordRepeat: this.passwordRepeat } };
        const self = this;
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.formSuccess = true;
          }
          self.loading = false;
        });
      }
    }
  },
  mounted () {
    if (this.$route.params.apiId && this.$route.query.token) {
      this.apiId = this.$route.params.apiId;
      this.resetToken = this.$route.query.token;
      const path = 'user/reset-password/get-reset-password-user/' + this.apiId + '?token=' + this.resetToken;
      const self = this;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.error) {
          self.resetToken = null;
          self.apiId = null;
        } else {
          self.email = response.data.email;
          self.name = response.data.name;
        }
        self.pageLoading = false;
      });
    } else {
      this.pageLoading = false;
    }
  }
}
